export default __webpack_public_path__ + "static/media/new-hero-1.d0b13b5f.svg";